import { render, staticRenderFns } from "./supervisePage.vue?vue&type=template&id=5f796a10&scoped=true"
import script from "./supervisePage.vue?vue&type=script&lang=js"
export * from "./supervisePage.vue?vue&type=script&lang=js"
import style0 from "./supervisePage.vue?vue&type=style&index=0&id=5f796a10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f796a10",
  null
  
)

export default component.exports